jQuery(document).ready($ => {

    if (window.matchMedia('(max-width: 767px)').matches) {
        $('.menu-item-has-children .sub-menu').slideUp();

        $('.menu-item-has-children').on('click', function() {
            $(this).siblings('.menu-item-has-children').children('.sub-menu').slideUp();
            $(this).children('.sub-menu').slideToggle();
            $(this).toggleClass('open');
            $(this).siblings('.menu-item-has-children').removeClass('open');
        });
    } else {
        $('.menu-item-has-children').hover(function() {
            $(this).toggleClass('open');
        })
    }



    $('.js-responsive-nav-button').on('click', function() {
        var $header = $('.js-header');
        var $responsiveNav = $('.js-responsive-nav');
        var $body = $('body');
        var headerHeight = $header.height();

        $(this).toggleClass('is-open');
        $responsiveNav.css('top', headerHeight);
        $responsiveNav.toggleClass('is-open');
        $body.toggleClass('is-locked');
    });
    
    // Cards Component Slider
    $('.js-card-slider').slick({
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        infinite: false,
        centerMode: true,
        responsive: [
            {
            breakpoint: 768,
            settings: 'unslick'
            }
        ]
    });

    // Packages/Pricing Component Slider
    $('.js-package-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        mobileFirst: true,
        infinite: false,
        centerMode: true,
        responsive: [
            {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: false
            }
            }
        ]
    });
     
    // Paintball Prices Component Slider
    $('.js-paintball-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        centerMode: true,
        mobileFirst: true,
        autoplay: true,
        responsive: [
            {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
            }
        ]
    });

    // Paintball Prices Component Slider
    $('.js-testimonials-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
    });

    // Booking Form Select2
    $('.js-select').select2({
        width: '215px',
        minimumResultsForSearch: -1
    });
    
    // Trigger datepicker on click
    $(".js-datepicker").on("click", function() {
        this.showPicker();
        $(this).addClass('is-active');
    });
    

    // Open/Close responsive booking form
    $('.js-open-booking-form').on('click', function() {
        $(this).addClass('is-deactivated');
        $('.js-hero-form').addClass('is-visible');
    });
    $('.js-form-close').on('click', function() {
        $('.js-open-booking-form').removeClass('is-deactivated');
        $('.js-hero-form').removeClass('is-visible');
    });

    $('.js-hero-form-category').on('change', function() {
        var newAction = $(this).val();
        $('.js-hero-form').attr('action', newAction);
    });


    // In Viewport Functionality
    let $elements = $('.js-in-viewport, .js-in-viewport-image, .js-in-viewport-custom');

    function isInViewport($element) {
        const rect = $element[0].getBoundingClientRect();
        return (
            rect.top < $(window).height() && rect.bottom > 0 &&
            rect.left < $(window).width() && rect.right > 0
        );
    }
    
    $elements.each(function() {
        
        if (isInViewport($(this)) || $(this).offset().top < $(window).scrollTop()) {
            $(this).addClass('in-viewport');
        }
    });
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                $(entry.target).addClass('in-viewport');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });
    
    $elements.each(function(i, element) {
        observer.observe(element);
    });
    
    

    // Functionality to hide the booking form on scroll (desktop only)
    const hideOnScrollObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const $target = $(entry.target);
            if (!entry.isIntersecting) {
                $target.addClass('is-hidden');
            } else {
                $target.removeClass('is-hidden');
            }
        });
    }, { rootMargin: "-25% 0% 0% 0%" });

    if($(window).width() > 798) {
        $('.js-hide-on-scroll').each(function() {
            hideOnScrollObserver.observe(this);
        });
    }
   
    $(window).scroll(function() {
        $elements.each(function() {
        
            //if ((($(window).outerHeight() >= $(this).offset().top) || ($(window).outerHeight() + $(window).scrollTop()) >= $(this).offset().top)) {
            if (isInViewport($(this)) || $(this).offset().top < $(window).scrollTop()) {
                $(this).addClass('in-viewport');
            }
        });

        var slowScrollUp = $(".js-slow-scroll-up");
        var slowScrollDown = $(".js-slow-scroll-down");
        var bgSlowScroll = $(".c-homepage-hero__bg");
    
        var originalTransitionSlowScrollUp = slowScrollUp.css('transition');
        var originalTransitionSlowScrollDown = slowScrollDown.css('transition');
        var originalBgTransition = bgSlowScroll.css('transition');
    
        if(slowScrollUp.hasClass('in-viewport')) {
            slowScrollUp.css('transition', 'none')
                       .css("transform", "translateY(" + (-$(this).scrollTop() / 8) + "px)");
        }
    
        if(slowScrollDown.hasClass('in-viewport')) {
            slowScrollDown.css('transition', 'none')
                         .css("transform", "translateY(" + ($(this).scrollTop() / 8) + "px)");
        }
        if(bgSlowScroll.hasClass('in-viewport')) {
            bgSlowScroll.css('transition', 'none')
                .css("background-position","50% " + (-$(this).scrollTop() / 12) + "px");
        }
    
        setTimeout(function() {
            slowScrollUp.css('transition', originalTransitionSlowScrollUp);
            slowScrollDown.css('transition', originalTransitionSlowScrollDown);
            bgSlowScroll.css('transition', originalBgTransition);
        }, 0);
    });
    
    
});